/************
 * Developed by : Shiva Software Solutions
 * Date : 23-06-2021
 * Descriptions : Dashboard api calling
 ************/

import React from 'react';

import { DIGIPOD_AUDIO_LIST, FETCH_START, FETCH_SUCCESS, FETCH_ERROR ,DIGIPOD_AUDIO_COUNT} from '../../shared/constants/ActionTypes';
import IntlMessages from '../../@crema/utility/IntlMessages';
import jwtAxios from '../../@crema/services/auth/jwt-auth/jwt-api';
import {fetchError, onWriteCloudWatchLog} from './Common';
//AWS cloud watch name
var streamname = 'Redux_Actions';
var filename = 'AudioDigitization.js';
//Get Patient completed List data

export const onGetDigiAudioList = (data) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      jwtAxios
        .post('v1/audioErx/getAudioERXPendingListJWT',data)
        .then((data) => {
          if (data.status === 200) {
            //Call pending list data - Get pending list data using token
            try {
              let pdata={
                "jwtToken": data.data.body['token']
              }
              jwtAxios
                .post('v1/audioErx/getAudioERXPendingList', pdata)
                .then((data) => {
                  if (data.status === 200) {
                    dispatch({type: FETCH_SUCCESS});
                    console.log(1888888)
                    dispatch({
                      type: DIGIPOD_AUDIO_LIST,
                      payload: data.data.body.data.resultData,
                    });
                     dispatch({
                      type: DIGIPOD_AUDIO_COUNT,
                      payload: data.data.body.data.totalCount,
                    });
                  } else {
                    dispatch({
                      type: FETCH_ERROR,
                      payload: <IntlMessages id='message.somethingWentWrong' />,
                    });
                  }
                })
                .catch((error) => {
                  dispatch({type: FETCH_ERROR, payload: error.message});
                  dispatch(
                    onWriteCloudWatchLog(
                      streamname,
                      filename,
                      'onGetPatientCompletedList',
                      '0',
                      error,
                    ),
                  );
                });
            } catch (err) {
              dispatch(fetchError(err.response.message));
              dispatch(
                onWriteCloudWatchLog(
                  streamname,
                  filename,
                  'onGetPatientCompletedList',
                  '0',
                  err,
                ),
              );
            }
          } else {
            dispatch({
              type: FETCH_ERROR,
              payload: <IntlMessages id='message.somethingWentWrong' />,
            });
          }
        })
        .catch((error) => {
          dispatch({type: FETCH_ERROR, payload: error.message});
          dispatch(
            onWriteCloudWatchLog(
              streamname,
              filename,
              'onGetPatientCompletedList',
              '0',
              error,
            ),
          );
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(
          streamname,
          filename,
          'onGetPatientCompletedList',
          '0',
          err,
        ),
      );
    }
  };
};

export const downloadMediEchoExcel = (data) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      jwtAxios
        .post('v1/audioErx/downloadAudioErxExcelJWT',data)
        .then((data) => {
          if (data.status === 200) {
            //Call pending list data - Get pending list data using token
            try {
              let pdata={
                "jwtToken": data.data.body['token']
              }
              jwtAxios
                .post('v1/audioErx/downloadAudioErxExcel', pdata,{ responseType: 'blob' })
                .then((res) => {
                  if (res.status === 200) {
                    dispatch({type: FETCH_SUCCESS});
                    const today = new Date();
                    const yyyy = today.getFullYear();
                    const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
                    const dd = String(today.getDate()).padStart(2, '0');

                    const formattedDate = `${yyyy}-${mm}-${dd}`; // e.g. "2025-09-12"
                    const filename = `MediEcho_erx_list_${formattedDate}.xlsx`;
                    // let filename ="MediEcho erx list" +new Date() + ".xlsx"
                    // let s = res.headers["content-type"] 
                    // console.log('res.headers:', res.headers);
                    // const disposition = res.headers["Content-disposition"];
                    // console.log('disposition',disposition)
                    // if (disposition && disposition.includes("filename=")) {
                    //   const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    //   if (match && match[1]) {
                    //     filename = match[1].replace(/['"]/g, "");
                    //   }
                    // }
                    const blob = res.data;
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                     a.href = url;
                     a.download = filename;
                     document.body.appendChild(a);
                     a.click();
                     a.remove();
                    window.URL.revokeObjectURL(url);
                  } else {
                    dispatch({
                      type: FETCH_ERROR,
                      payload: <IntlMessages id='message.somethingWentWrong' />,
                    });
                  }
                })
                .catch((error) => {
                  dispatch({type: FETCH_ERROR, payload: error.message});
                  dispatch(
                    onWriteCloudWatchLog(
                      streamname,
                      filename,
                      'onGetPatientCompletedList',
                      '0',
                      error,
                    ),
                  );
                });
            } catch (err) {
              dispatch(fetchError(err.response.message));
              dispatch(
                onWriteCloudWatchLog(
                  streamname,
                  filename,
                  'onGetPatientCompletedList',
                  '0',
                  err,
                ),
              );
            }
          } else {
            dispatch({
              type: FETCH_ERROR,
              payload: <IntlMessages id='message.somethingWentWrong' />,
            });
          }
        })
        .catch((error) => {
          dispatch({type: FETCH_ERROR, payload: error.message});
          dispatch(
            onWriteCloudWatchLog(
              streamname,
              filename,
              'onGetPatientCompletedList',
              '0',
              error,
            ),
          );
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(
          streamname,
          filename,
          'onGetPatientCompletedList',
          '0',
          err,
        ),
      );
    }
  };
};